import { type HttpClient } from '@/application/interfaces/http-client';

import { addProductsToCart } from './add-products-to-cart';
import addServicesToCart from './add-services-to-cart';
import changeShipmentModality from './change-shipment-modality';
import getCartShipments from './get-cart-shipments';
import getCartSummary from './get-cart-summary';

const cartService = (httpClient: HttpClient.Instance) => ({
  addProductsToCart: addProductsToCart(httpClient),
  addServicesToCart: addServicesToCart(httpClient),
  changeShipmentModality: changeShipmentModality(httpClient),
  getCartShipments: getCartShipments(httpClient),
  getCartSummary: getCartSummary(httpClient),
});

export default cartService;
